import { offset } from '@floating-ui/react';
import React from 'react';
import { FocusOn } from 'react-focus-on';
import { noop } from '../../../utils/noop.js';
import { usePopper } from '../../../utils/usePopper.js';
import { getDataTestId } from '../../../utils/utils.js';
import { Card } from '../../Card/Card.js';
import { CardBody } from '../../Card/CardBody.js';
import { CardFooter } from '../../Card/CardFooter.js';
import { Portal } from '../../Portal/Portal.js';
export function DateInputPickerLayout({ actions, calendar, dataMetrics, dataTestId: propsDataTestId, inputs, open, onCancel = noop }) {
    const { refs, floatingStyles, getFloatingProps } = usePopper({
        placement: 'bottom-start',
        strategy: 'fixed',
        middleware: [offset(2)]
    });
    const dataTestId = getDataTestId('layout', propsDataTestId);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-metrics": dataMetrics, "data-testid": getDataTestId('trigger', dataTestId), ref: refs.setReference }, inputs),
        React.createElement(Portal, { "data-metrics": dataMetrics, dataTestId: getDataTestId('portal', dataTestId) }, open && (React.createElement("div", { ref: refs.setFloating, style: floatingStyles, ...getFloatingProps() },
            React.createElement(FocusOn, { enabled: open, noIsolation: true, onClickOutside: onCancel, onEscapeKey: onCancel, scrollLock: false },
                React.createElement(Card, { addClassName: "twds-w-min twds-bg-white dark:twds-bg-gray-950 dark:twds-border twds-border-gray-300 dark:twds-border-gray-900", dataTestId: `${dataTestId}-card` },
                    React.createElement(CardBody, { dataTestId: `${dataTestId}-card_body`, addClassName: "twds-flex twds-flex-col twds-space-y-2 twds-pl-0 twds-pr-0 twds-pb-0 twds-pt-0" }, calendar),
                    React.createElement(CardFooter, { addClassName: "twds-border-gray-300 dark:twds-border-gray-900 twds-border-t dark:twds-border-t", dataTestId: `${dataTestId}-actions_footer` }, actions))))))));
}
//# sourceMappingURL=date_input_picker_layout.js.map